import { deleteMagicFileApi } from "../../api/FileUploadApi";
import {
  AddToCartApi,
  ClearCartApi,
  ContactUsApi,
  fileUploadCompleteApi,
  GetAllCartItemApi,
  GetDeliveryChargeApi,
  magicFileUrlApi,
  RemoveCartItemApi,
  UpdateCartItemApi,
} from "../../api/product-processing-api/CartApi";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Async thunks for API calls
export const AddToCart = createAsyncThunk(
  "cart/AddToCart",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AddToCartApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const UpdateCartItem = createAsyncThunk(
  "cart/UpdateCartItem",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await UpdateCartItemApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const RemoveCartItem = createAsyncThunk(
  "cart/RemoveCartItem",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await RemoveCartItemApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const ClearCart = createAsyncThunk(
  "cart/ClearCart",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ClearCartApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const GetAllCartItem = createAsyncThunk(
  "cart/GetAllCartItem",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetAllCartItemApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const GetDeliveryCharge = createAsyncThunk(
  "cart/GetDeliveryCharge",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetDeliveryChargeApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const deleteMagicFile = createAsyncThunk(
  "cart/deleteMagicFile",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteMagicFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const magicFileUrl = createAsyncThunk(
  "cart/magicFileUrl",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await magicFileUrlApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const fileUploadComplete = createAsyncThunk(
  "cart/fileUploadComplete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fileUploadCompleteApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const SubmitContactUs = createAsyncThunk(
  "cart/SubmitContactUs",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ContactUsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message || err?.message,
      });
    }
  },
);

// Initial state

const initialState = {
  loading: false,
  clearCartLoading: false,
  removeLoading: false,
  updateLoading: false,
  AddToCartPayload: {
    productId: 0,
    quantity: 0,
    cartCustomizationItem: [],
    colorId: 0,
    sizeId: 0,
    noteAnswer: "",
    guestToken: "",
    extraProductChargeId: 0,
    designId: 0,
    extraChargeSelected: false,
    videoImageMapDTOS: [
      // {
      //   imageUploads: {},
      //   videoUploads: {},
      // },
    ],
  },

  CustomPhotoModal: false,
  CustomPhotoModalStep: 1,
  cartItems: {},
  cartResponse: {},
  deliveryResponse: {},

  deleting: false,
  uploading: false,
  magicimageurl: {},
  videomap: {},
  contactUsLoading: false,
  contactUsResponse: {},
  contactUsError: "",
};

// Slice definition
const CartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setAddToCartPayload: (state, action) => {
      const payload = action.payload || {};
      state.AddToCartPayload = {
        orderItemId: payload?.orderItemId || null,
        productId: payload.productId || 0,
        quantity: payload.quantity || 0,
        cartCustomizationItem: Array.isArray(payload.cartCustomizationItem)
          ? payload.cartCustomizationItem
          : [],
        colorId: payload.colorId || 0,
        sizeId: payload.sizeId || 0,
        noteAnswer: payload.noteAnswer || "",
        guestToken: payload.guestToken || "",
        extraProductChargeId: payload.extraProductChargeId || 0,
        designId: payload.designId || 0,
        extraChargeSelected: Boolean(payload.extraChargeSelected),
        videoImageMapDTOS: Array.isArray(payload.videoImageMapDTOS)
          ? payload.videoImageMapDTOS
          : [],
      };
    },
    setAddToCartImagePayload: (state, action) => {
      const {
        productId,
        quantity,
        imgUploadId,
        imagePayload,
        cartCustomizationItem,
        colorId,
        sizeId,
        noteAnswer,
        guestToken,
        extraProductChargeId,
        designId,
        extraChargeSelected,
      } =
        action.payload || {};

      state.AddToCartPayload.productId = productId;
      state.AddToCartPayload.quantity = quantity;
      if (Array.isArray(cartCustomizationItem)) {
        state.AddToCartPayload.cartCustomizationItem = cartCustomizationItem;
      }
      state.AddToCartPayload.colorId = colorId || 0;
      state.AddToCartPayload.sizeId = sizeId || 0;
      state.AddToCartPayload.noteAnswer = noteAnswer || "";
      state.AddToCartPayload.guestToken = guestToken || "";
      state.AddToCartPayload.extraProductChargeId = extraProductChargeId || 0;
      state.AddToCartPayload.designId = designId || 0;
      state.AddToCartPayload.extraChargeSelected = Boolean(extraChargeSelected);

      if (imgUploadId) {
        const index = state.AddToCartPayload.videoImageMapDTOS.findIndex(
          (item) => item?.imageUploads?.uploadId === imgUploadId,
        );

        if (index !== -1) {
          // remove matched item
          state.AddToCartPayload.videoImageMapDTOS.splice(index, 1);
        }
      } else {
        state.AddToCartPayload.videoImageMapDTOS.push({
          imageUploads: imagePayload,
          videoUploads: null,
        });
      }
    },

    setAddToCartVideoPayload: (state, action) => {
      const { imgUploadId, videoPayload } = action.payload;
      console.log("Slice video", action.payload);
      // debugger
      const index = state.AddToCartPayload.videoImageMapDTOS.findIndex(
        (item) => item?.imageUploads?.uploadId === imgUploadId,
      );

      if (index !== -1) {
        console.log("Slice video ind", action.payload);
        state.AddToCartPayload.videoImageMapDTOS[index].videoUploads =
          videoPayload || null;
      }
    },

    setCustomPhotoModal: (state, action) => {
      state.CustomPhotoModal = action.payload;
    },
    setCustomPhotoModalStep: (state, action) => {
      state.CustomPhotoModalStep = action.payload || 1;
    },
    updateDeliveryResponse: (state, action) => {
      state.deliveryResponse = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AddToCart.pending, (state) => {
        state.loading = true;
        state.cartResponse = {};
      })
      .addCase(AddToCart.fulfilled, (state, action) => {
        state.loading = false;
        state.cartResponse = action.payload.response;
      })
      .addCase(AddToCart.rejected, (state) => {
        state.loading = false;
        state.cartResponse = {};
      });

    builder
      .addCase(UpdateCartItem.pending, (state) => {
        state.updateLoading = true;
        // state.cartItems = {};
      })
      .addCase(UpdateCartItem.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.cartItems = action.payload.response;
      })
      .addCase(UpdateCartItem.rejected, (state) => {
        state.updateLoading = false;
        state.cartItems = {};
      });

    builder
      .addCase(RemoveCartItem.pending, (state) => {
        state.removeLoading = true;
        // state.cartItems = {};
      })
      .addCase(RemoveCartItem.fulfilled, (state, action) => {
        state.removeLoading = false;
        state.cartItems = action.payload.response;
      })
      .addCase(RemoveCartItem.rejected, (state) => {
        state.removeLoading = false;
        state.cartItems = {};
      });

    builder
      .addCase(ClearCart.pending, (state) => {
        state.clearCartLoading = true;
      })
      .addCase(ClearCart.fulfilled, (state, action) => {
        state.clearCartLoading = false;
        state.cartItems = {};
      })
      .addCase(ClearCart.rejected, (state) => {
        state.clearCartLoading = false;
      });

    builder
      .addCase(GetAllCartItem.pending, (state) => {
        state.loading = true;
        state.cartItems = {};
      })
      .addCase(GetAllCartItem.fulfilled, (state, action) => {
        state.loading = false;
        state.cartItems = action.payload.response;
      })
      .addCase(GetAllCartItem.rejected, (state) => {
        state.loading = false;
        state.cartItems = {};
      });

    builder
      .addCase(GetDeliveryCharge.pending, (state) => {
        state.loading = true;
        state.deliveryResponse = {};
      })
      .addCase(GetDeliveryCharge.fulfilled, (state, action) => {
        state.loading = false;
        state.deliveryResponse = action.payload.response;
      })
      .addCase(GetDeliveryCharge.rejected, (state) => {
        state.loading = false;
        state.deliveryResponse = {};
      });

    // get magic url
    builder.addCase(magicFileUrl.pending, (state) => {
      state.magicimageurl = {};
      state.uploading = true;
    });
    builder.addCase(magicFileUrl.fulfilled, (state, action) => {
      state.magicimageurl = action?.payload?.response;
      state.uploading = true;
    });
    builder.addCase(magicFileUrl.rejected, (state) => {
      state.magicimageurl = {};
      state.uploading = false;
    });

    // map magic url
    builder.addCase(fileUploadComplete.pending, (state) => {
      state.videomap = {};
      state.uploading = true;
    });
    builder.addCase(fileUploadComplete.fulfilled, (state, action) => {
      state.videomap = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(fileUploadComplete.rejected, (state) => {
      state.videomap = {};
      state.uploading = false;
    });

    // delete magic url
    builder.addCase(deleteMagicFile.pending, (state) => {
      state.deleting = true;
    });
    builder.addCase(deleteMagicFile.fulfilled, (state, action) => {
      state.deleting = false;
    });
    builder.addCase(deleteMagicFile.rejected, (state) => {
      state.deleting = false;
    });

    builder.addCase(SubmitContactUs.pending, (state) => {
      state.contactUsLoading = true;
      state.contactUsResponse = {};
      state.contactUsError = "";
    });
    builder.addCase(SubmitContactUs.fulfilled, (state, action) => {
      state.contactUsLoading = false;
      state.contactUsResponse = action?.payload?.response || {};
      state.contactUsError = "";
    });
    builder.addCase(SubmitContactUs.rejected, (state, action) => {
      state.contactUsLoading = false;
      state.contactUsResponse = {};
      state.contactUsError =
        action?.payload?.errorMessage || "Something went wrong";
    });
  },
});

export const {
  setAddToCartPayload,
  setCustomPhotoModal,
  setCustomPhotoModalStep,
  setAddToCartImagePayload,
  setAddToCartVideoPayload,
  updateDeliveryResponse,
} = CartSlice.actions;
export default CartSlice.reducer;
